<template>
  <v-container>
    <h1>Admin Page</h1>
    <v-list light>
      <template v-for="page in pages">
        <v-list-tile :to="page.path" :key="page.path">
          {{ page.title }}
        </v-list-tile>
      </template>
    </v-list>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    pages: []
  }),
  mounted: function () {
    // Get our sub-pages from the router
    var r = this.$router.options.routes
    for (var i = 0; i < r.length; i++) {
      if (r[i].path.startsWith('/admin/') &&
          r[i].meta.displayName) {
        this.pages.push({
          path: r[i].path,
          title: r[i].meta.displayName
        })
      }
    }
  }
}
</script>
